<!-- <div class="row col-md-12"> -->
<div class="col-md-12 no-padding">
  <!--START HEADER-->

  <header #qrb class="header_block">
    <nav class="navbar navbar-expand-sm">
      <div class="container-fluid">
        <div class="navbar-header">
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <!-- <a class="navbar-brand cursor-pointer" routerLink="/app/dashboard"><img src="assets/images/logo/logo2.png" alt="logo" class="img-responsive" />
          </a> -->
          <div class="logo2-header clearfix">
            <div class="logo-first-hd">
              <a class="cursor-pointer" routerLink="/app/dashboard"> <img src="assets/images/logo/tl_logo.png"
                  class="img-responsive" alt="logo2"  /></a>
            </div>
            <div class="line-hgt-hd"></div>
            <div class="logo-second-hd">
              <a class="cursor-pointer" routerLink="/app/dashboard"><img src="assets/images/logo/tasnim.png"
                  class="img-responsive" alt="logo2" /></a>
            </div>
          </div>

        </div>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <div class="navbar-nav mr-auto">
            <span class="line"></span>
            <p>INTEGRATED LOGISTICS MANAGEMENT SYSTEM</p>
          </div>
          <!-- <div style="margin-right: 20px;" > 
        <mat-icon matBadge="{{notificationCount}}">notifications_active</mat-icon>  style="width: 30px;height: 30px;cursor: pointer;" 
             <img src="assets/images/bell/bell.png" (click)="showBellCarrier()"  alt="button" 
             class="img-responsive" 
          </div> -->
          <div class="bell-container" *ngIf="isShowNotification">
          <i class="fa fa-bell" (click)="showBellCarrier()"  alt="button"> </i> 
          <span class="badge" *ngIf="notificationCount > 0">  {{ notificationCount }}
          </span>
          </div>
          <div style="margin-right: 20px;" *ngIf="isShowWeatherModal">
            <img src="assets/images/weather/weather_menu.png" (click)="showWeatherModal(true)" style="width: 30px;height: 30px;cursor: pointer;"  alt="button"
              class="img-responsive" />
          </div>

          <div class="header_right" style="z-index: 1040">
            <div class="dropdown">
              <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">Logged in As
                <i class="fa fa-angle-down" aria-hidden="true"></i></button>
              <p>{{loggerUserDetails}}</p>
              <span class="line"></span>
              <ul class="dropdown-menu">
                <!-- <li><a href="#">Switch Context</a></li>-->
                <li><a (click)="onChangePassword()" class="cursor-pointer"><i class="fa fa-lock" aria-hidden="true"></i>
                    Change Password</a></li>
                <!-- <a><a href="#"><i class="fa fa-sign-out" aria-hidden="true"></i> Logout</a></li> -->
                <li *ngIf="canShowPMS" class="cursor-pointer" (click)="onOpenPMS()"><i class="fa fa-tasks pms-icon"
                    aria-hidden="true" title="PMS"></i><span class="pms-text">PMS</span></li>
                <li class="cursor-pointer" (click)="onEnterQrCode()"><i class="fa fa-qrcode pms-icon" aria-hidden="true"
                    title="PMS"></i><span class="pms-text">My QR</span></li>
                <li #actualTarget class="cursor-pointer" (click)="onClickAddDependant(op, $event, actualTarget)"><i
                    class="fa fa-tasks pms-icon" aria-hidden="true" title="PMS"></i><span
                    class="pms-text">Dependant(s)</span></li>
              </ul>
            </div>

            <div class="Logout navbar-right">
              <a (click)="onLogout()"><img src="assets/images/navigation/logout.png" alt="button"
                  class="img-responsive" /></a>
            </div>
          </div>

        </div>
      </div>
    </nav>
  </header>

  <!--END HEADER-->

  <section class="main_block">
    <div class="row">
      <div class="left_column col-md-1 full-height">
        <div class="sidebar_nav">
          <ul *ngIf="transactionsItems">
            <li *ngFor="let item of transactionsItems">
              <a class="tooltip"><img [src]="'assets/images/navigation/' + item.ENTRY_ID + '.png'" alt="icon"
                  class="img-responsive" (click)="onNavigateToSelectedComponent(item.ENTRY_ID, 'transaction')"
                  [pTooltip]="item.menuText" escape="false" /></a>
            </li>
          </ul>
        </div>
        <div class="p-sidebar">
          <p-sidebar [(visible)]="showSidebar" [baseZIndex]="10000" position="left">
            <div class="row">
              <div *ngIf="masterItems && masterItems.length" class="col-md-6">
                <h4 class="text-align-center">Masters</h4>
                <ul class="master-ul">
                  <li *ngFor="let item of masterItems"><a
                      (click)="onNavigateToSelectedComponent(item.ENTRY_ID, 'master')">{{item.menuText}}</a></li>
                </ul>
              </div>
              <div *ngIf="reportsItems && reportsItems.length" class="col-md-6">
                <h4 class="text-align-center">Reports</h4>
                <ul class="master-ul">
                  <!-- <li><a (click)="onNavigateToSelectedComponent('', 'report')">Request Status Report</a></li> -->
                  <li *ngFor="let item of reportsItems"><a
                      (click)="onNavigateToSelectedComponent(item.ENTRY_ID, 'reports')">{{item.menuText}}</a></li>
                  <!-- <li><a (click)="onNavigateToSelectedComponent('RRT', 'reports')">Request Routing</a></li> -->
                  <!-- <li (click)="onNavigateToSelectedComponent('SM', 'SM')" style="cursor: pointer; padding-left: 10px;">Shuttle Management</li>  -->
                </ul>
              </div>
            </div>
          </p-sidebar>
          <button *ngIf="(masterItems && masterItems.length) || (reportsItems && reportsItems.length)" pButton
            type="button" class="sidebar-button" (click)="showSidebar = true" title="Master Components"><i
              class="fa fa-bars"></i></button>
        </div>
      </div>
      <div id="right-section" class="right_column col-md-11" data-Outer="true">
        <div class="main-content">
          <router-outlet></router-outlet>
        </div>
        <div>
          <ng-template #defaultFooter></ng-template>
          <ng-container *ngTemplateOutlet="footerSection ? footerSection : defaultFooter"></ng-container>
        </div>

      </div>
    </div>
  </section>
</div>
<p-confirmDialog *ngIf="showConfirmDialog" [closeOnEscape]="false" [closable]="false"></p-confirmDialog>


<!--START FOOTER-->
<!-- <footer>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <p>Copyright &copy; 2019. Bahwan CyberTek. All Rights Reserved.</p>
        </div>
        <div class="col-md-6">
          <p class="pwr">Powered by <img alt="logo" width="100px" class="img-responsive" src="assets/images/logo/CueTrans-logo.png"></p>
        </div>
      </div>
    </div>
  </footer> -->
<!--END FOOTER-->

<!-- QR Section -->
<div id="qr-block" *ngIf="mouseEnteredToQRCode" class="qr-code-zoom">
  <i class="fa fa-times qr-print" title="Close" (click)="onLeaveQrCode()"></i>
  <button class="fa fa-print qr-print" title="Print" (click)="onPrintQr()"></button>
  <div id="qr">
    <span class="padding-left-10"><b>{{printQrId}}</b></span>
    <qrcode [qrdata]="printQrId" [width]="400" [errorCorrectionLevel]="'M'"></qrcode>
  </div>
</div>

<p-overlayPanel #op id="dependant-op" [showCloseIcon]="true" [style]="{width: '30vw'}" [dismissable]="false"
  [appendTo]="qrb" [styleClass]="'dependent-home-list'">
  <ng-template pTemplate>
    <div class="text-transform-capitalise">
      <div *ngFor="let dependant of dependantList; let i = index;" class="row no-padding cursor-pointer"
        style="border-radius: 5px; background-color: #f4f4f4; margin: 7px;">
        <div class="col-md-8 text-align-left">
          <div class="col-md-12 padding-7" title="Dependant Name">{{dependant.dependent_name}}</div>
          <div class="col-md-12 padding-7" title="Dependant Relationship">{{dependant.relationship}}</div>
        </div>
        <div id="qr-block-op" class="col-md-3 margin-top-5">
          <qrcode [qrdata]="dependant.rf_id" [width]="60" [errorCorrectionLevel]="'M'"
            (click)="onEnterQrCode(dependant)">
          </qrcode>
        </div>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>